import { useIsActivityOld } from "hooks/useIsActivityOld/useIsActivityOld";
import { useIsUserSciduck } from "hooks/useIsUserSciduck/useIsUserSciduck";
import { useUser } from "hooks/user/useUser";

export function useShouldSeeReviewOnboarding(): boolean {
  const user = useUser();
  const isUserSciDuck = useIsUserSciduck();
  const { isOld, loading } = useIsActivityOld("last_label_creation_date");

  if (isUserSciDuck) {
    return false;
  }

  if (loading) {
    return false;
  }

  return isOld || !user.userprofile.review_onboarded;
}
